import {LangKeyType} from '../../../../../../../provider/locale/translation/type';
import {YandexCompanyStatusEnum} from '../../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

export const wgisActualizationStatusMarkPopoverTitleLangKey: Record<YandexCompanyStatusEnum, LangKeyType> = {
    [YandexCompanyStatusEnum.Actualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_STATUS__POPOVER_TITLE__ACTUALIZED',
    [YandexCompanyStatusEnum.NotActualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_STATUS__POPOVER_TITLE__NOT_ACTUALIZED',
    [YandexCompanyStatusEnum.NeedActualize]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_STATUS__POPOVER_TITLE__NEED_ACTUALIZATION',
};

export const wgisActualizationStatusMarkPopoverContentLangKey: Record<YandexCompanyStatusEnum, LangKeyType> = {
    [YandexCompanyStatusEnum.Actualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_STATUS__POPOVER_CONTENT__ACTUALIZED',
    [YandexCompanyStatusEnum.NotActualized]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_STATUS__POPOVER_CONTENT__NOT_ACTUALIZED',
    [YandexCompanyStatusEnum.NeedActualize]:
        'REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_STATUS__POPOVER_CONTENT__NEED_ACTUALIZATION',
};
